var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/chevron-right"),React.createElement("g",{"id":"icon/chevron-right","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path-Copy","fill":"currentColor","fillRule":"nonzero","points":"9.06714628 0 5 3.76888889 18.1990408 16 5 28.2311111 9.06714628 32 26.3333333 16"}))]);
}

ChevronRight.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
